module.exports = {
  type: 'cart',
  id: 'cart',
  icon: 'shopping-cart',
  title: 'ProjectDetails.cart',
  bodyClass: 'no-padding',
  hidePrices: false,
  requireShipping: true,

  orderDialog: [
    {
      id: 'suppliers',
      form: [
        {
          id: 'description',
          type: 'multi',
          label: {
            en: 'Comment',
            de: 'Kommentar',
          }
        },
        {
          id: 'terms',
          type: 'checkbox',
          checkValue: false,
          required: false,
          label: {
            en: 'Request customer approval (NOT IMPLEMENTED)',
            de: 'Kundenfreigabe anfordern (NICHT IMPLEMENTIERT)'
          }
        }
      ]
    }
  ]
}
